
module part {
  'use strict';

  export class PartOrderDetailCtrl {


    // $inject annotation.
    // It provides $injector with information about dependencies to be injected into constructor
    // it is better to have it close to the constructor, because the parameters must match in count and type.
    // See http://docs.angularjs.org/guide/di
    public static $inject = [
      '$scope',
      '$timeout',
      'partService',
      'anchorNavService',
      'pageMetaService',
      '$mdDialog',
      '$mdSidenav',
    ];

    // dependencies are injected via AngularJS $injector
    // controller's name is registered in Application.ts and specified from ng-controller attribute in index.html
    constructor(
      private $scope: IPartOrderDetailControllerScope,
      private $timeout: ng.ITimeoutService,
      private partService: IPartService, 
      private anchorNavService: navigation.IAnchorNavService,
      private pageMetaService: navigation.IPageMetaService,
      private $mdDialog: ng.material.IDialogService,
      private $mdSidenav: ng.material.ISidenavService ,
    ) {

      // 'vm' stands for 'view model'. We're adding a reference to the controller to the scope
      // for its methods to be accessible from view / HTML
      $scope.vm = this;
      $scope.showButton = false;
      $scope.meta = pageMetaService.getPageMeta;

      $scope.showPartDetail = false;

      anchorNavService.subscribeOnLocationChanged($scope, (event: ng.IAngularEvent, re: IRouteEntry) => {
        this.load(re);
      });
      this.load(pglob.RouteData.RouteEntry);

      this.$timeout(() => { $scope.showButton = true; })
      
    }

    locals: { };

    load(re: IRouteEntry) {
      this.$scope.requestOnGoing = true;
      this.partService.loadPartsByProduct(re.RouteParameterStack).then(( data: ServiceData ) => {
        this.setData(data);
      });
      this.partService.loadAvailabilityByProduct(re.RouteParameterStack).then(( data: AvailabilityServiceData ) => {
        this.$scope.availability = data;
      });
    }


    setData(data: ServiceData) {
      this.$scope.data = data;
      this.$scope.categories = data.PartsReference.Kategorien;
      this.$scope.referenceGroups = data.ReferenceGroup;

      this.setSelectedCategory(this.$scope.categories[0]);

      var rpm: IRouteParameter = this.pageMetaService.searchRouteParameter("ProductName");
      if (!rpm) return;
      this.$scope.productName = rpm.DisplayName[this.$scope.meta('hlFull')];

      this.$scope.requestOnGoing = false;
    };

    closeDialog() {
      this.$mdDialog.hide();
    }

    setSelectedCategory(category: ArtikelReferenzKategorie) {
      this.$scope.selectedCategory = category;
      this.$scope.selectedGroup = category.Gruppen[0];
      if (this.$mdSidenav('left').isLockedOpen()) this.scroll();
    }


    getSelectedCategory(): ArtikelReferenzKategorie{
      return this.$scope.selectedCategory;
    }

    setSelectedGroup(group: ArtikelReferenzGruppe) {
      this.$scope.partsearch = null;
      this.$scope.selectedGroup = group;
      this.$timeout(() => {
        this.scroll();
      })
      
    }

    scroll(): void {
      var offset = -46;
      if (this.$scope.categories[0] == this.$scope.selectedCategory && this.$scope.categories[0].Gruppen[0] == this.$scope.selectedGroup) offset = -200; //different offset for first element, cause of header.

      this.$mdSidenav('left').close().then(() => {
        (<any>$).smoothScroll({
          scrollElement: $("#part-list"),
          scrollTarget: '#sh-' + this.$scope.selectedCategory.Nummer + "-" + this.$scope.selectedGroup.Nummer,
          offset: offset,
        });
      });
    }


    getSelectedGroup(): ArtikelReferenzGruppe {
      return this.$scope.selectedGroup;
    }

    toggleSideNav(id): void {
      this.$mdSidenav(id).toggle();
    }

    showPartDetail(): void {
      this.$scope.showPartDetail = true;
    }

    hidePartDetail(): void {
      this.$scope.showPartDetail = false;
    }

    openDetailModal($event: MouseEvent, part: Part, p2p: Part2Product): void {
      this.$scope.partDetailData = null;
      this.loadPart(part.ID, p2p);
    }

    loadPart(partid: string, p2p: Part2Product) {
      this.$scope.requestOnGoing = true;
      this.partService.loadDetail(partid).then((response) => {
        this.$scope.requestOnGoing = false;
        this.$scope.partDetailData = response.data;
        this.$scope.showPartDetail = true;
        this.$scope.partToProduct = p2p;
      });
    }

  }

}